import { Tooltip } from '@wistia/vhs';
import { styled } from 'styled-components';
import type { JSX } from 'react';

export const MAX_WIDTH_FOR_CONTENT_BELOW_MEDIA = 1500;

export const LetterBox = styled.div<{ color?: string }>`
  background-color: #${({ color }) => color ?? 'transparent'};
  position: relative;
`;

export const LetterBoxLightener = styled.div`
  background-color: white;
  inset: 0;
  opacity: 0.8;
  position: absolute;
`;

export const StuffBelowMediaContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  margin: 0 auto;
  max-width: ${MAX_WIDTH_FOR_CONTENT_BELOW_MEDIA}px;
  padding: 0 ${({ theme }) => theme.spacing.space07};
  row-gap: ${({ theme }) => theme.spacing.space06};
  width: 100%;
`;

export const TitleAndDescriptionContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  row-gap: ${({ theme }) => theme.spacing.space04};
`;

export const CommentingDisabledTooltip = ({
  disabled,
  children,
}: {
  disabled: boolean;
  children: JSX.Element;
}): JSX.Element => {
  return disabled ? (
    <Tooltip
      label="Commenting not supported within preview"
      direction="left"
    >
      {children}
    </Tooltip>
  ) : (
    children
  );
};
